import { useStore } from "@store/index"

export const useSubtopicsCollection = (topicId: string) => {
  const { expertInsightsStore } = useStore()
  return expertInsightsStore.subtopicsStore.getCollection(topicId)
}

export default useSubtopicsCollection
